import * as api from "./client";
import { buildFilesUrl } from "./filesUrl";

export type MarketingUserGuide = {
  slug: string;
  content: string;
  updatedAt: string;
  updatedBy: string | null;
};

export type MarketingUserGuideResponse = {
  userGuide: MarketingUserGuide;
  requestId?: string | null;
};

export type MarketingUserGuideImage = {
  hash: string;
  filename: string;
  /** Absolute, because staff-ui is cross-origin from the asset host. */
  url: string;
};

/** Max length marketing-api accepts, mirrored so the page refuses before the round trip. */
export const USER_GUIDE_MAX_LENGTH = 50_000;

export const marketingUserGuide = {
  get: async (): Promise<MarketingUserGuideResponse> => {
    return api.get<MarketingUserGuideResponse>("/v1/user-guide");
  },

  save: async (content: string): Promise<MarketingUserGuideResponse> => {
    return api.put<MarketingUserGuideResponse>("/v1/user-guide", { content });
  },

  uploadImage: async (file: File): Promise<MarketingUserGuideImage> => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.fetchRaw("/v1/user-guide/images", {
      method: "POST",
      body: formData,
    });
    if (!response.ok) {
      let message = `Failed to upload file: HTTP ${response.status}`;
      try {
        const body = (await response.json()) as { error?: unknown };
        if (typeof body.error === "string") message = body.error;
      } catch {
        // keep default
      }
      throw new Error(message);
    }
    const raw = (await response.json()) as Record<string, unknown>;
    const hash = String(raw.hash ?? "");
    const filename = String(raw.filename ?? file.name);
    const url = buildFilesUrl({ hash, filename });
    if (!url) throw new Error("Could not build the image URL. Please try again.");
    return { hash, filename, url };
  },
};
